import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Send, CheckCircle2 } from 'lucide-react';
export function SupportPage() {
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  if (submitted) {
    return <div className="max-w-xl mx-auto pt-16 text-center" data-id="element-2732">
        <div className="bg-green-50 h-20 w-20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-2733">
          <CheckCircle2 className="h-10 w-10 text-green-600" data-id="element-2734" />
        </div>
        <h2 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-2735">
          Request Received
        </h2>
        <p className="text-slate-600 mb-8" data-id="element-2736">
          Thanks for reaching out. Our support team has been notified and will
          get back to you shortly.
        </p>
        <Button onClick={() => setSubmitted(false)} variant="outline" data-id="element-2737">
          Send Another Request
        </Button>
      </div>;
  }
  return <div className="max-w-xl mx-auto space-y-8" data-id="element-2738">
      <div data-id="element-2739">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-2740">Support</h1>
        <p className="text-slate-500" data-id="element-2741">Need help? Send us a message.</p>
      </div>

      <Card data-id="element-2742">
        <CardHeader data-id="element-2743">
          <CardTitle data-id="element-2744">Submit a Request</CardTitle>
        </CardHeader>
        <CardContent data-id="element-2745">
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-2746">
            <div data-id="element-2747">
              <label className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-2748">
                Category
              </label>
              <select className="block w-full rounded-lg border-slate-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm" data-id="element-2749">
                <option data-id="element-2750">Technical Issue</option>
                <option data-id="element-2751">Feature Request</option>
                <option data-id="element-2752">Account & Billing</option>
                <option data-id="element-2753">Other</option>
              </select>
            </div>

            <Input label="Project (Optional)" placeholder="e.g. The Oakwood" data-id="element-2754" />

            <div data-id="element-2755">
              <label className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-2756">
                Message
              </label>
              <textarea rows={5} className="block w-full rounded-lg border-slate-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm" placeholder="Describe your issue or request..." required data-id="element-2757" />
            </div>

            <div className="pt-2" data-id="element-2758">
              <Button type="submit" className="w-full" leftIcon={<Send className="h-4 w-4" data-id="element-2760" />} data-id="element-2759">
                Submit Request
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>;
}